import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import injectSheet, { withTheme } from 'react-jss'
import cn from 'classnames'
import flow from 'lodash/flow'
import Card from '../Card/ArticleSummaryCard'
import HeroCard from '../Card/ArticleHeroGridCard'
import Section from '../Widgets/Section'

class HeroGrid extends PureComponent {

  render() {
    const { classes, page, slice, theme } = this.props;
    const { main_article, top_right_article, bottom_right_article } = slice
    const color = page ? theme.getLandingPageColor(page.landing_page_uid) : undefined

    const renderArticleCard = (article, showSummary, className) => (
      <Card className={cn(classes.card, className)}
        article={article}
        size={'small'}
        showArticleTime={true}
        showSummary={showSummary}
        color={color}
        hoverEffect={false}
      />
    )

    return (
      <Section className={classes.root}>
        <div className={classes.heroCard}>
          <HeroCard
            article={main_article}
            showArticleTime
            showSummary
            color={color}
          />
        </div>
        <div className={classes.sideContainer}>
          {renderArticleCard(top_right_article, false, classes.top)}
          {renderArticleCard(bottom_right_article, false)}
        </div>
      </Section>
    )
  }
}

const mapStateToProps = (state) => ({
})

export default flow([
  injectSheet((theme) => ({
    root: {
      marginTop: theme.spacing.normal,
      [theme.breakpoint('laptop')]: {
        justifyContent: 'space-between',
        display: 'flex'
      }
    },
    container: {
      marginBottom: 32,
      [theme.breakpoint('laptop')]: {
        marginBottom: 64
      }
    },
    heroCard: {
      width: '100%',
      [theme.breakpoint('laptop')]: {
        width: `calc(66% + ${theme.ds.spacing(4)}px)`,
        paddingRight: theme.ds.spacing(2),
      }
    },
    sideContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      [theme.breakpoint('laptop')]: {
        width: '33%'
      }
    },
    top: {
      marginBottom: theme.ds.spacing(4)
    }
  })),
  withTheme
])( connect(mapStateToProps)(HeroGrid) );



// WEBPACK FOOTER //
// ./src/components/LandingPage/HeroGrid.js